import { createContext, useContext, useState } from "react";

const ChatProductsContext = createContext({
  chatProducts: [],
  setChatProducts: () => {},
});

export const ChatProductsProvider = ({ children }) => {
  const [chatProducts, setChatProducts] = useState([]);

  return (
    <ChatProductsContext.Provider value={{ chatProducts, setChatProducts }}>
      {children}
    </ChatProductsContext.Provider>
  );
};

export const useChatProducts = () => useContext(ChatProductsContext);



